import React, { useState, useEffect } from 'react'
// import { FixedSizeList as List } from 'react-window'
// import InfiniteLoader from 'react-window-infinite-loader'

import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import { useGlobalStore } from '../../../../store'
import { MuiCheckbox, AccordionWithArrow, MessageReactQuery } from '../../../../components'
import forumService from '../../../../services/forum.service'
import { useReactQuery } from '../../../../hooks/useReactQuery'
import { getObjectAsArray } from '../../../../util'
import { CheckboxWrapper, Title } from './style'

/*
const LOADING = 1
const LOADED = 2
const itemStatusMap = {}

const isItemLoaded = index => !!itemStatusMap[index]
const loadMoreItems = (startIndex, stopIndex) => {
  for (let index = startIndex; index <= stopIndex; index++) {
    itemStatusMap[index] = LOADING
  }
  return new Promise(resolve =>
    setTimeout(() => {
      for (let index = startIndex; index <= stopIndex; index++) {
        itemStatusMap[index] = LOADED
      }
      resolve()
    }, 2500)
  )
}

const Row = ({ index }) => {
  consoleLog('indexValue = ', index, itemStatusMap)

  if (itemStatusMap[index] !== LOADED) {
    return (
      <div className='ListItem'>Loading...</div>
    )
  }

  return (
    <div className='ListItem'>
      Row {index}
      <MuiCheckbox key={'multipleChoiceQuestion1__' + index} label={`Row ${index}`} value={`Row-${index}`} />
    </div>
  )
}
*/

const MultiChoiceItemMarketResearchQuestions = ({ data, mode, onChange, expanded }) => {
  const { company } = useGlobalStore()

  const [multipleChoiceQuestionCounts, setMultipleChoiceQuestionCounts] = useState([0, 0])
  const [formSelectData, setFormSelectData] = useState({
    multipleChoiceQuestion1: [],
    multipleChoiceQuestion2: []
  })

  const onChangeHandler = (e, key, index) => {
    const array = formSelectData[key]
    array[index].checked = e.target.checked
    const finalArray = { ...formSelectData, [key]: array }
    setFormSelectData(finalArray)
  }

  const useReactQueryObject1 = {
    payloadDetails: {
      queryId: ['QuestionMulti1'],
      urlFunc: forumService.getOrganizationAggregationQuestionMulti1Api,
      payload: { organizationId: company?.OrganizationId }
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const useReactQueryObject2 = {
    payloadDetails: {
      queryId: ['QuestionMulti2'],
      urlFunc: forumService.getOrganizationAggregationQuestionMulti2Api,
      payload: { organizationId: company?.OrganizationId }
    },
    useReactQueryObject: { cacheTime: 10000 }
  }
  const { data: data1, isLoading: isLoading1, isSuccess: isSuccess1, isError: isError1, error: error1 } = useReactQuery(useReactQueryObject1)
  const { data: data2, isLoading: isLoading2, isSuccess: isSuccess2, isError: isError2, error: error2 } = useReactQuery(useReactQueryObject2)

  /*
  const onload = async () => {
    const payload = { organizationId: company?.OrganizationId }
    const multipleChoiceQuestion1Api = await forumService.getOrganizationAggregationQuestionMulti1Api(payload)
    const multipleChoiceQuestion1Array = (getObjectAsArray(multipleChoiceQuestion1Api, 'adv')).map(d => ({ label: d, value: d, checked: data?.MultipleChoiceQuestion1.includes(d) }))
    const count1 = multipleChoiceQuestion1Array.filter(f => f.checked === true).length

    const multipleChoiceQuestion2Api = await forumService.getOrganizationAggregationQuestionMulti2Api(payload)
    const multipleChoiceQuestion2Array = (getObjectAsArray(multipleChoiceQuestion2Api, 'adv')).map(d => ({ label: d, value: d, checked: data?.MultipleChoiceQuestion2.includes(d) }))
    const count2 = multipleChoiceQuestion2Array.filter(f => f.checked === true).length

    setMultipleChoiceQuestionCounts([count1, count2])
    setFormSelectData({ multipleChoiceQuestion1: multipleChoiceQuestion1Array, multipleChoiceQuestion2: multipleChoiceQuestion2Array })
  }
  */

  const hasDataAndNotDisabled = (value) => {
    if (mode) { return (value) && mode }
    return true
  }

  const limitingArray = (array) => {
    if (array?.length > 50) {
      array.slice(0, 50)
    }
    return array
  }

  useEffect(() => {
    const checkedData = {
      multipleChoiceQuestion1: formSelectData.multipleChoiceQuestion1.filter((v) => v?.checked),
      multipleChoiceQuestion2: formSelectData.multipleChoiceQuestion2.filter((v) => v?.checked)
    }
    setMultipleChoiceQuestionCounts([checkedData.multipleChoiceQuestion1.length, checkedData.multipleChoiceQuestion2.length])
    onChange(checkedData)
  }, [formSelectData])

  // useEffect(() => {
  //   onload()
  // }, [])

  const onSuccess1Func = (resp) => {
    const multipleChoiceQuestion1Arr = (getObjectAsArray(resp, 'adv'))
    const multipleChoiceQuestion1ArrayFiltered = data?.MultipleChoiceQuestion1?.length > 0
      ? data.MultipleChoiceQuestion1.map(d => ({ label: d, value: d, checked: true }))
      : []
    const multipleChoiceQuestion1ArrayData = multipleChoiceQuestion1Arr.filter(f => !data?.MultipleChoiceQuestion1.includes(f)).map(d => ({ label: d, value: d, checked: data?.MultipleChoiceQuestion1.includes(d) }))

    // const multipleChoiceQuestion1Array = multipleChoiceQuestion1Arr.map(d => ({ label: d, value: d, checked: data?.MultipleChoiceQuestion1.includes(d) }))
    const multipleChoiceQuestion1Array = [...multipleChoiceQuestion1ArrayFiltered, ...multipleChoiceQuestion1ArrayData]
    const count1 = multipleChoiceQuestion1Array.filter(f => f.checked === true).length
    setMultipleChoiceQuestionCounts([count1, multipleChoiceQuestionCounts[1]])
    setFormSelectData(prev => ({ ...prev, multipleChoiceQuestion1: multipleChoiceQuestion1Array }))
  }
  useEffect(() => {
    if (isSuccess1 && data1?.length) onSuccess1Func(data1)
  }, [isSuccess1, data1])

  const onSuccess2Func = (resp) => {
    const multipleChoiceQuestion2Array = (getObjectAsArray(resp, 'adv')).map(d => ({ label: d, value: d, checked: data?.MultipleChoiceQuestion2.includes(d) }))
    const count2 = multipleChoiceQuestion2Array.filter(f => f.checked === true).length
    setMultipleChoiceQuestionCounts([multipleChoiceQuestionCounts[0], count2])
    setFormSelectData(prev => ({ ...prev, multipleChoiceQuestion2: multipleChoiceQuestion2Array }))
  }
  useEffect(() => {
    if (isSuccess2 && data2?.length) onSuccess2Func(data2)
  }, [isSuccess2, data2])

  return (
    <AccordionWithArrow title='Multi-choice Item Market Research Questions' expanded={expanded} accordionstyle='fieldset' showOverlay={mode}>
      <MessageReactQuery
        isLoading={isLoading1 || isLoading2}
        isSuccess={isSuccess1 || isSuccess2}
        data={data1 || data2}
        isError={isError1 || isError2}
        error={error1 || error2}
      />
      <Grid container spacing={2}>
        {/* <Grid item xs={12}>
          <Title>Multiple-choice Question 1 {multipleChoiceQuestionCounts[0] > 0 && <span>(Selected: {multipleChoiceQuestionCounts[0]})</span>}</Title>
          <InfiniteLoader
            isItemLoaded={isItemLoaded}
            itemCount={1000}
            loadMoreItems={loadMoreItems}
          >
            {({ onItemsRendered, ref }) => (
              <List
                className='List'
                height={150}
                itemCount={1000}
                itemSize={30}
                onItemsRendered={onItemsRendered}
                ref={ref}
                width={300}
              >
                <Row index={0} data={formSelectData.multipleChoiceQuestion1} />
                <Row />
                {Row}
              </List>
            )}
          </InfiniteLoader>
        </Grid> */}

        <Grid item xs={6}>
          <Title>Multiple-choice Question 1 {multipleChoiceQuestionCounts[0] > 0 && <span>(Selected: {multipleChoiceQuestionCounts[0]})</span>}</Title>
          <CheckboxWrapper>
            {limitingArray(formSelectData.multipleChoiceQuestion1).map((list, i) => {
              if (!hasDataAndNotDisabled(list.checked)) { return false }
              return (
                <MuiCheckbox key={'multipleChoiceQuestion1__' + i} label={list.label} value={list.value} checked={list?.checked} onChange={(e) => onChangeHandler(e, 'multipleChoiceQuestion1', i)} disabled={mode} />
              )
            })}
          </CheckboxWrapper>
        </Grid>
        <Grid item xs={6}>
          <Title>Multiple-choice Question 2 {multipleChoiceQuestionCounts[1] > 0 && <span>(Selected: {multipleChoiceQuestionCounts[1]})</span>}</Title>
          <CheckboxWrapper>
            {limitingArray(formSelectData.multipleChoiceQuestion2).map((list, i) => {
              if (!hasDataAndNotDisabled(list.checked)) { return false }
              return (
                <MuiCheckbox key={'multipleChoiceQuestion2__' + i} label={list.label} value={list.value} checked={list?.checked} onChange={(e) => onChangeHandler(e, 'multipleChoiceQuestion2', i)} disabled={mode} />
              )
            })}
          </CheckboxWrapper>
        </Grid>

      </Grid>
    </AccordionWithArrow>
  )
}

MultiChoiceItemMarketResearchQuestions.propTypes = {
  data: PropTypes.object,
  mode: PropTypes.bool,
  onChange: PropTypes.func,
  expanded: PropTypes.bool
}

export default MultiChoiceItemMarketResearchQuestions
